export default "🦈🐳🐋🐊🐆🐅🐃🐂🐄🐪🐣🐥🐺🦊🐗🐴🦌🦄🐝🐛🦋🐌🐞🐶🐱🐭🐹🐰🐻🐼🐨🐯🦁🐮🐷🐽🐸🐵🙈🙉🙊🐒🦍🐔🐢🐍🦎🐫🐘🦏🐐🐏🐑🐎🐖🦇🐓🦃🦅🦆🦉🐇🐀🐁🐙🦑🦀🦐🐠🐟🐡🐬🐧🐦🐤🐜🦂🐾🐉🐲"